
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import T from '../../lang';
import { types } from '../../api_types';
import * as ui from '../../ui';

import arena_Clarification from './Clarification.vue';
import arena_NewClarification from './NewClarificationPopup.vue';
import omegaup_Overlay from '../Overlay.vue';
import clarificationsStore from '../../arena/clarificationsStore';
import common_Paginator from '../common/Paginator.vue';

export enum PopupDisplayed {
  None,
  NewClarification,
}

@Component({
  components: {
    'omegaup-clarification': arena_Clarification,
    'omegaup-arena-new-clarification-popup': arena_NewClarification,
    'omegaup-overlay': omegaup_Overlay,
    'omegaup-common-paginator': common_Paginator,
  },
})
export default class ArenaClarificationList extends Vue {
  @Prop({ default: false }) isAdmin!: boolean;
  @Prop() clarifications!: types.Clarification[];
  @Prop({ default: () => [] }) problems!: types.NavbarProblemsetProblem[];
  @Prop({ default: () => [] }) users!: types.ContestUser[];
  @Prop({ default: PopupDisplayed.None }) popupDisplayed!: PopupDisplayed;
  @Prop() problemAlias!: null | string;
  @Prop() username!: null | string;
  @Prop({ default: false }) showNewClarificationPopup!: boolean;
  @Prop({ default: false }) allowFilterByAssignment!: boolean;
  @Prop() pageSize!: number;
  @Prop() page!: number;
  @Prop() pagerItems!: types.PageItem[];

  T = T;
  ui = ui;
  PopupDisplayed = PopupDisplayed;
  currentPopupDisplayed = this.popupDisplayed;
  selectedAssignment: string | null = null;
  selectedProblem: string | null = null;

  onNewClarification(): void {
    this.currentPopupDisplayed = PopupDisplayed.NewClarification;
  }

  onPopupDismissed(): void {
    this.currentPopupDisplayed = PopupDisplayed.None;
    this.$emit('update:activeTab', 'clarifications');
  }

  clarificationSelected(clarificationId: number): boolean {
    return (
      clarificationsStore.state.selectedClarificationId === clarificationId
    );
  }

  get assignmentsNames(): Array<string | null> {
    return this.allowFilterByAssignment
      ? [
          ...new Set(
            this.clarifications.map(
              (clarification) => clarification.assignment_alias ?? null,
            ),
          ),
        ]
      : [];
  }

  get problemsNames(): string[] {
    return [
      ...new Set(
        this.clarifications.map((clarification) => clarification.problem_alias),
      ),
    ];
  }

  get filteredClarifications(): types.Clarification[] {
    return this.clarifications.filter(
      (clarification) =>
        (this.selectedAssignment === null ||
          clarification.assignment_alias === this.selectedAssignment) &&
        (this.selectedProblem === null ||
          clarification.problem_alias === this.selectedProblem),
    );
  }

  @Watch('showNewClarificationPopup')
  onShowNewClarificationPopupChanged(newValue: boolean): void {
    if (!newValue) {
      this.currentPopupDisplayed = PopupDisplayed.None;
      return;
    }
    this.currentPopupDisplayed = PopupDisplayed.NewClarification;
    this.onNewClarification();
  }

  @Watch('popupDisplayed')
  onPopupDisplayedChanged(newValue: PopupDisplayed): void {
    this.currentPopupDisplayed = newValue;
    if (newValue === PopupDisplayed.None) return;
    if (newValue === PopupDisplayed.NewClarification) {
      this.onNewClarification();
    }
  }
}
